module.exports = __webpack_public_path__ + "img/Romina-Sanchez-byn.94a3d27e.jpg";